<template>
  <div id="delete">
    <h2>{{ $t('message.delete.title') }}</h2>
    <p>{{ $t('message.delete.sub_title') }}</p>
    <hr>
    <div v-show="result">
      <div v-show="!success">
        <p class="has-text-danger">{{ errMsg }}</p>
      </div>
      <div v-show="success">
        <p class="has-text-success">{{ $t("message.delete.success") }}</p>
      </div>
    </div>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="!loading && main">
      <section>
        <p>{{ $t('message.delete.1') }}</p>
        <b-input v-model.trim="fileName" type="email" maxlength="50"></b-input>
        <button class="button is-primary" v-on:click="deleteFile">{{ $t("message.delete.exec") }}</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Delete',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: true,
      fileName: '',
      errMsg: ''
    }
  },
  methods: {
    deleteFile: function () {
      this.main = false
      this.loading = true

      this.$axios.get(this.baseURL + '/delete?file_name=' + this.fileName, { withCredentials: true })
        .then(response => {
          this.loading = false
          this.result = true
          this.success = true
        }).catch((response) => {
          this.loading = false
          this.result = true
          this.success = false

          if ((typeof response.data) === 'undefined') {
            this.errMsg = this.$t('message.delete.error.connection')
          }
          if (response.response.data === 'not_allowed') {
            this.errMsg = this.$t('message.delete.error.not_allowed')
          } else if (response.response.data === 'get_users_files') {
            this.errMsg = this.$t('message.delete.error.get_users_files')
          } else if (response.response.data === 'delete_from_db') {
            this.errMsg = this.$t('message.delete.error.delete_from_db')
          } else if (response.response.data === 'delete') {
            this.errMsg = this.$t('message.delete.error.delete')
          } else {
            this.errMsg = this.$t('message.delete.error.unknown')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Delete.vue